import { render, staticRenderFns } from "./RequestDetailFormNew.vue?vue&type=template&id=cc10fc1a&scoped=true"
import script from "./RequestDetailFormNew.vue?vue&type=script&lang=ts"
export * from "./RequestDetailFormNew.vue?vue&type=script&lang=ts"
import style0 from "./RequestDetailFormNew.vue?vue&type=style&index=0&id=cc10fc1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc10fc1a",
  null
  
)

export default component.exports